// src/components/SearchBar.tsx
import React from 'react';
import { Search, Lock, Loader2 } from 'lucide-react';

interface SearchBarProps {
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  onSearchSubmit?: () => void;
  isLoading?: boolean;
  isLocked?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({ 
  searchTerm, 
  onSearchTermChange, 
  onSearchSubmit,
  isLoading = false,
  isLocked = false
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSearchSubmit && !isLocked && !isLoading) {
      onSearchSubmit();
    }
  };

  return (
    <div className="search-bar-container" style={{ 
      position: 'relative', 
      maxWidth: '800px', 
      width: '100%',
      margin: '0 auto 2rem auto',
    }}>
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          type="text"
          placeholder={isLocked ? "Search is locked. Please sign in." : "Search for HS Codes (e.g., 0808.10) or Descriptions..."}
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          onKeyDown={handleKeyPress}
          disabled={isLocked}
          className="custom-input"
          style={{ 
            paddingLeft: '3.5rem', 
            height: '60px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            backgroundColor: isLocked ? '#f1f5f9' : 'white',
            cursor: isLocked ? 'not-allowed' : 'text'
          }}
        />
        <Search 
          size={24} 
          color="#64748b" 
          style={{ 
            position: 'absolute', 
            left: '1.25rem', 
            top: '50%', 
            transform: 'translateY(-50%)',
            pointerEvents: 'none'
          }} 
        />
        
        {onSearchSubmit && (
          <button 
            onClick={onSearchSubmit} 
            disabled={isLoading || isLocked}
            className="custom-button search-btn-responsive"
          >
            {isLoading ? (
               <Loader2 className="animate-spin" size={20} />
            ) : isLocked ? (
               <Lock size={20} />
            ) : (
               "Search"
            )}
          </button>
        )}
      </div>
      <style>
        {`
          .search-btn-responsive {
            position: absolute;
            right: 8px;
            top: 8px;
            bottom: 8px;
            background-color: #2563eb;
            color: white;
            border: none;
            border-radius: 12px;
            padding: 0 1.5rem;
            height: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          }
          .search-btn-responsive:disabled {
             background-color: #94a3b8;
             cursor: not-allowed;
          }
          @media (max-width: 640px) {
            .search-btn-responsive {
               padding: 0 1rem;
            }
            .search-btn-responsive span {
               display: none;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SearchBar;